<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    mail
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName"
                                    [disabled]="isSearchMarqueeDisabled">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to locate messages-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <!--<mat-tab-group *ngIf="searchResult.length > 0">
                    <mat-tab label="Results">
                        <br />-->
                <table mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                    <ng-container matColumnDef="FromAvatarBlobPath">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            <mat-icon class="material-symbols-outlined">
                                <app-image srcPath="{{ message.FromAvatarBlobPath == null ? appService.defaultImageUri : message.FromAvatarBlobPath }}" isApiImage="{{ message.FromAvatarBlobPath == null ? 'false' : 'true' }}" (click)="editItem(message.MessageId)" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                            </mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="From">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.From }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ToContacts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.ToContacts }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CcContacts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>CC</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.CcContacts }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="BccContacts">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>BCC</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.BccContacts }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Subject">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.Subject }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="SentOnUTC">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sent On (UTC)</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.SentOnUTC }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CreatedOnUTC">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On (UTC)</th>
                        <td mat-cell *matCellDef="let message" (click)="editItem(message.MessageId)">
                            {{ message.CreatedOnUTC }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Delete">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let message">
                            <button mat-button (click)="deleteItem(message.MessageId, message.From)">
                                <mat-icon class="material-symbols-outlined">
                                    delete_forever
                                </mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                    <!--</mat-tab>
                </mat-tab-group>-->
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
